import makeApiRequest from './makeApiRequest';

const getWalletTransaction = () => {
	const postApiRequest = makeApiRequest('GET');

	const getTransaction = async (apiBase: string, walletId: any) => postApiRequest(`${apiBase}/api/wallets/${walletId}/transactions`, {});

	return [getTransaction];
};

export default getWalletTransaction;
